import React from "react";

import { CiStar } from "react-icons/ci";
import { AiFillStar } from "react-icons/ai";
import { FaPoundSign } from "react-icons/fa";

const OrderSummary = ({showfees = false}) => {
  const cartItems = JSON.parse(localStorage.getItem("cartItems")) || []; // Example for cart
  const totalPrice = cartItems.reduce((acc, item) => acc + item.basePrice * item.quantity, 0);


  return (
      <table className="w-full text-left h-[90%]">
        <thead>
          <tr className="bg-[#AF313D] lg:h-[97.86px] sm:h-[29.72px] md:text-[19.78px] md:h-[68.4px] h-[29.72px] text-[8.59px] sm:text-[8.59px] font-baloo font-medium text-white lg:text-[28.3px] uppercase">
            <th className="px-4 py-2">Items</th>
            <th className="px-4 py-2">Qty</th>
            <th className="px-4 py-2">Price</th>
            <th className="px-4 py-2">Total Price</th>
          </tr>
        </thead>
        <tbody>
          {cartItems?.map((item, index) => (
           <tr key={item.id} className=" border-b border-[#ddd]">
  {/* Item Column */}
  <td className="pl-[8px] pr-4 py-2 flex items-center gap-4">
    <img
      src={item?.images?.[0] ||item?.image}
      // alt={item.name}
      className="lg:w-[107.06px] md:w-[74.84px] md:h-[71.84px] lg:h-[102.58px] sm:w-[32.52px] sm:h-[31.52px] w-[32.52px] h-[31.52px] object-cover rounded"
    />
    <div>
      <p className="text-sm lg:text-[14.15px] text-[8.3px] md:text-[11.3px] sm:text-[8.3px] font-medium text-[#C97C2A]">
        {item.category}
      </p>
      <p className="lg:text-[18.86px] text-[8.73px] sm:text-[8.73px] md:text-[11.3px] font-baloo font-medium lg:leading-10">
        {item.name}
      </p>
     
    </div>
  </td>

  {/* Quantity */}
  <td className="sm:px-4 px-5 md:px-6 py-2 font-bold sm:text-[6.45px] text-[6.45px] lg:text-[21.22px] md:text-[14.83px]">
    {item.quantity}x
  </td>

  {/* Price */}
  <td className="px-4 py-2 text-[6.45px] sm:text-[6.45px] lg:text-[21.22px] md:text-[14.83px]">
  <div className="flex items-center ">
  <FaPoundSign className="mr-1" />{item.basePrice}
  </div>
  </td>

  {/* Total Price */}
  <td className="sm:px-4 px-8 md:px-10 py-2 text-[6.45px] sm:text-[6.45px] lg:text-[21.22px] md:text-[14.83px]">
  <div className="flex items-center ">
  <FaPoundSign className="mr-1" />{item.basePrice *item.quantity}
  </div>
  </td>
</tr>

          ))}
        </tbody>
      </table>
  );
};

export default OrderSummary;
